<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <div>
        <div class="page-content">
            <div class="container-fluid">
                <v-overlay :value="overlay">
                    <v-progress-circular indeterminate size="64"></v-progress-circular>
                </v-overlay>

                <div class="row">
                    <div class="col-12 mb-4">
                        <v-card>
                            <v-card-title>
                                Ajouter un nouveau produit
                                <v-spacer></v-spacer>
                            </v-card-title>

                            <v-form ref="form" v-model="valid" :lazy-validation="lazy">
                                <!--<v-alert v-if="errors" dense outlined
                                         :type="(errors.update_error)?'error':'success'">
                                    {{errors.operation}}
                                </v-alert>-->
                                <v-stepper v-model="e1">
                                    <v-stepper-header>
                                        <v-stepper-step :complete="e1 > 1" step="1">PRODUITS</v-stepper-step>

                                        <v-divider></v-divider>

                                        <v-stepper-step :complete="e1 > 2" step="2">DC</v-stepper-step>

                                        <v-divider></v-divider>

                                        <v-stepper-step :complete="e1 > 3" step="3">PP</v-stepper-step>

                                        <v-divider></v-divider>

                                        <v-stepper-step :complete="e1 > 4" step="4">DP</v-stepper-step>

                                        <v-divider></v-divider>


                                        <v-stepper-step step="5">FIN</v-stepper-step>
                                    </v-stepper-header>

                                    <v-stepper-items>
                                        <v-stepper-content step="1">

                                            <label style="font-weight: bold; margin-bottom: 2%; font-size: 12pt">
                                                Etape:1 Informations du produits</label>
                                            <div class="col-12 text-center">
                                                <img src="../../public/mineimages/img_upload.png" height="180"
                                                     id="image_id" class="Preview_image">
                                            </div>

                                            <v-row>
                                                <input type="hidden" name="" id="update_id" :value="$route.params.id">
                                                <v-col cols="12" sm="6" md="6">
                                                    <v-file-input label="Image du produit" placeholder="Choisir"
                                                                  v-on:change="Preview_image($event)"
                                                                         v-model="editedItem.photo"
                                                                  id="input_file"></v-file-input>
                                                    <span style="color: red" class="error-box" v-show="errors.photo">{{errors.photo}}</span>
                                                </v-col>

                                                <v-col cols="12" sm="6" md="6">
                                                    <v-text-field
                                                            clearable
                                                            v-model="editedItem.default_price"
                                                            label="Prix par défaut"
                                                            placeholder="ex : 2580"></v-text-field>
                                                    <span style="color: red" class="error-box"
                                                          v-show="errors.default_price">{{errors.default_price}}</span>

                                                </v-col>
                                            </v-row>
                                            <v-row>
                                                <v-col cols="12" sm="6" md="6">
                                                    <v-text-field
                                                            clearable
                                                            v-model="editedItem.reference"
                                                            label="Référence"
                                                            placeholder="ex : #4554148785"></v-text-field>
                                                    <span style="color: red" class="error-box"
                                                          v-show="errors.reference">{{errors.reference}}</span>

                                                </v-col>

                                                <v-col cols="12" sm="6" md="6">
                                                    <v-text-field
                                                            clearable
                                                            v-model="editedItem.denomination"
                                                            label="Dénomination"
                                                            placeholder="ex : Efferalgan"></v-text-field>
                                                    <span style="color: red" class="error-box"
                                                          v-show="errors.denomination">{{errors.denomination}}</span>

                                                </v-col>
                                            </v-row>

                                            <v-row v-for="(item, index) in composition" v-bind:key="item"
                                                   :id="index+'row'">
                                                <v-col cols="12" sm="6" md="6">
                                                    <v-text-field
                                                            clearable
                                                            label="Composition qualitatives" name="composition[]"
                                                            placeholder="ex : Paracétamol" :value="item"></v-text-field>
                                                </v-col>


                                                <v-col cols="10" sm="5" md="5">
                                                    <v-text-field
                                                            :value="quantity[index]"
                                                            clearable
                                                            label="Composition quantitatives" name="quantity[]"
                                                            placeholder="ex : 5mg"></v-text-field>
                                                </v-col>
                                                <v-col v-if="index===0" cols="2" sm="1" md="1">
                                                    <v-btn @click="add_cqq" class="mx-2" fab dark small color="primary">
                                                        <v-icon dark>mdi-plus</v-icon>
                                                    </v-btn>
                                                </v-col>
                                                <v-col v-else cols="2" sm="1" md="1">
                                                    <v-btn class="mx-2" @click="remove_cqq(index)" fab dark small
                                                           color="red">
                                                        <v-icon dark>mdi-minus</v-icon>
                                                    </v-btn>
                                                </v-col>

                                            </v-row>
                                            <span style="color: red" class="error-box" v-show="errors.cqq">{{errors.cqq}}</span>


                                            <v-row>
                                                <v-col cols="12" sm="6" md="6">
                                                    <v-select
                                                            id="fps"
                                                            v-model="editedItem.fp"
                                                            item-text="nom"
                                                            item-value="_id"
                                                            :items="formepharmacetiques"
                                                            label="Forme pharmaceutique"
                                                            placeholder="Choisissez"
                                                            dense
                                                            required

                                                    ></v-select>
                                                    <span style="color: red" class="error-box" v-show="errors.fp">{{errors.fp}}</span>

                                                </v-col>


                                                <v-col cols="12" sm="6" md="6">
                                                    <v-select
                                                            id="categories"
                                                            v-model="editedItem.categorie_slug"
                                                            item-text="libel"
                                                            item-value="_id"
                                                            :items="categories"
                                                            label="Catégorie"
                                                            placeholder="Choisissez"
                                                            dense
                                                            required

                                                    ></v-select>
                                                    <span style="color: red" class="error-box"
                                                          v-show="errors.categorie_slug">{{errors.categorie_slug}}</span>

                                                </v-col>

                                            </v-row>

                                            <v-btn @click="save" color="success" style="margin-right: 1%"> Finaliser
                                            </v-btn>

                                            <v-btn color="primary" style="margin-right: 1%"
                                                   @click="valideBtnStep1Click"> Continuer
                                            </v-btn>

                                        </v-stepper-content>
                                        <v-stepper-content step="2">
                                            <label style="font-weight: bold; margin-bottom: 2%; font-size: 12pt">
                                                Etape:2 Données Clinique (optionnel)</label>
                                            <v-row>
                                                <v-col cols="12" sm="12" md="12">
                                                    <v-textarea
                                                            v-model="editedItem.it"
                                                            rows="2"
                                                            clearable
                                                            label="Indications thérapeutiques"
                                                            value=""
                                                    ></v-textarea>
                                                </v-col>
                                            </v-row>
                                            <v-row>
                                                <v-col cols="12" sm="12" md="12">
                                                    <v-textarea
                                                            v-model="editedItem.pma"
                                                            rows="2"
                                                            clearable
                                                            label="Posologie et mode d'administration"
                                                            value=""
                                                    ></v-textarea>
                                                </v-col>
                                            </v-row>

                                            <v-row>
                                                <v-col cols="12" sm="12" md="12">
                                                    <v-textarea
                                                            v-model="editedItem.ci"
                                                            rows="2"
                                                            clearable
                                                            label="Contre indication"
                                                            value=""
                                                    ></v-textarea>
                                                </v-col>
                                            </v-row>
                                            <v-row>
                                                <v-col cols="12" sm="12" md="12">
                                                    <v-textarea
                                                            v-model="editedItem.mgspe"
                                                            rows="2"
                                                            clearable
                                                            label="Mise en garde spécial et précaution d'emploi"
                                                            value=""
                                                    ></v-textarea>
                                                </v-col>
                                            </v-row>
                                            <v-row>
                                                <v-col cols="12" sm="12" md="12">
                                                    <v-textarea
                                                            v-model="editedItem.imafi"
                                                            rows="2"
                                                            clearable
                                                            label="Interrations avec d'autre médicaments et autres formes d'interrractions"
                                                            value=""
                                                    ></v-textarea>
                                                </v-col>
                                            </v-row>
                                            <v-row>
                                                <v-col cols="12" sm="12" md="12">
                                                    <v-textarea
                                                            v-model="editedItem.gs"
                                                            rows="2"
                                                            clearable
                                                            label="Grossesse"
                                                            value=""
                                                    ></v-textarea>
                                                </v-col>
                                            </v-row>

                                            <v-row>
                                                <v-col cols="12" sm="12" md="12">
                                                    <v-textarea
                                                            v-model="editedItem.alt"
                                                            rows="2"
                                                            clearable
                                                            label="Allaitement"
                                                            value=""
                                                    ></v-textarea>
                                                </v-col>
                                            </v-row>


                                            <v-row>
                                                <v-col cols="12" sm="12" md="12">
                                                    <v-textarea
                                                            v-model="editedItem.eacvum"
                                                            rows="2"
                                                            clearable
                                                            label="Effet sur aptitude à conduire des véhicules et à utiliser des machines"
                                                            value=""
                                                    ></v-textarea>
                                                </v-col>
                                            </v-row>


                                            <v-row>
                                                <v-col cols="12" sm="12" md="12">
                                                    <v-textarea
                                                            v-model="editedItem.ei"
                                                            rows="2"
                                                            clearable
                                                            label="Effet indésirables"
                                                            value=""
                                                    ></v-textarea>
                                                </v-col>
                                            </v-row>

                                            <v-row>
                                                <v-col cols="12" sm="12" md="12">
                                                    <v-textarea
                                                            v-model="editedItem.sd"
                                                            rows="2"
                                                            clearable
                                                            label="Surdosage"
                                                            value=""
                                                    ></v-textarea>
                                                </v-col>
                                            </v-row>

                                            <v-btn @click="save" color="success" style="margin-right: 1%"> Finaliser
                                            </v-btn>


                                            <v-btn
                                                    color="primary"
                                                    @click="e1 = 3"
                                                    style="margin-right: 1%"
                                            >
                                                Continuer
                                            </v-btn>

                                            <v-btn text @click="e1 = 1">Retour</v-btn>
                                        </v-stepper-content>
                                        <v-stepper-content step="3">
                                            <label style="font-weight: bold; margin-bottom: 2%; font-size: 12pt">
                                                Etape:3 Propriétés pharmacologiques (optionnel)</label>
                                            <v-row>
                                                <v-col cols="12" sm="12" md="12">
                                                    <v-textarea
                                                            v-model="editedItem.pd"
                                                            rows="2"
                                                            clearable
                                                            label="Pharmacodynamique"
                                                            value=""
                                                    ></v-textarea>
                                                </v-col>
                                            </v-row>
                                            <v-row>
                                                <v-col cols="12" sm="12" md="12">
                                                    <v-textarea
                                                            v-model="editedItem.pc"
                                                            rows="2"
                                                            clearable
                                                            label="Pharmacocinétique"
                                                            value=""
                                                    ></v-textarea>
                                                </v-col>
                                            </v-row>
                                            <v-row>
                                                <v-col cols="12" sm="12" md="12">
                                                    <v-textarea
                                                            v-model="editedItem.dsp"
                                                            rows="2"
                                                            clearable
                                                            label="Données de sécurité préclinique"
                                                            value=""
                                                    ></v-textarea>
                                                </v-col>
                                            </v-row>

                                            <v-btn @click="save" color="success" style="margin-right: 1%"> Finaliser
                                            </v-btn>


                                            <v-btn
                                                    color="primary"
                                                    @click="e1 = 4"
                                                    style="margin-right: 1%"
                                            >
                                                Continuer
                                            </v-btn>

                                            <v-btn text @click="e1 = 2">Retour</v-btn>
                                        </v-stepper-content>
                                        <v-stepper-content step="4">
                                            <label style="font-weight: bold; margin-bottom: 2%; font-size: 12pt">
                                                Etape:4 Données pharmaceutiques (optionnel)</label>
                                            <v-row>
                                                <v-col cols="12" sm="12" md="12">
                                                    <v-textarea
                                                            v-model="editedItem.le"
                                                            rows="2"
                                                            clearable
                                                            label="Liste des expients"
                                                            value=""
                                                    ></v-textarea>
                                                </v-col>
                                            </v-row>
                                            <v-row>
                                                <v-col cols="12" sm="12" md="12">
                                                    <v-textarea
                                                            v-model="editedItem.ic"
                                                            rows="2"
                                                            clearable
                                                            label="Incompatibilités"
                                                            value=""
                                                    ></v-textarea>
                                                </v-col>
                                            </v-row>
                                            <v-row>
                                                <v-col cols="12" sm="12" md="12">
                                                    <v-textarea
                                                            v-model="editedItem.dc"
                                                            rows="2"
                                                            clearable
                                                            label="Durée de conservation"
                                                            value=""
                                                    ></v-textarea>
                                                </v-col>
                                            </v-row>

                                            <v-row>
                                                <v-col cols="12" sm="12" md="12">
                                                    <v-textarea
                                                            v-model="editedItem.pcc"
                                                            rows="2"
                                                            clearable
                                                            label="Précaution particlière de conservation"
                                                            value=""
                                                    ></v-textarea>
                                                </v-col>
                                            </v-row>
                                            <v-row>
                                                <v-col cols="12" sm="12" md="12">
                                                    <v-textarea
                                                            v-model="editedItem.ncee"
                                                            rows="2"
                                                            clearable
                                                            label="Nature et contenu de l'emballage extérieur"
                                                            value=""
                                                    ></v-textarea>
                                                </v-col>
                                            </v-row>
                                            <v-row>
                                                <v-col cols="12" sm="12" md="12">
                                                    <v-textarea
                                                            v-model="editedItem.ppem"
                                                            rows="2"
                                                            clearable
                                                            label="Précautions particulières d'élimination et de manipulation"
                                                            value=""
                                                    ></v-textarea>
                                                </v-col>
                                            </v-row>

                                            <v-btn @click="save" color="success" style="margin-right: 1%"> Finaliser
                                            </v-btn>


                                            <v-btn
                                                    color="primary"
                                                    @click="e1 = 5"
                                                    style="margin-right: 1%"
                                            >
                                                Continuer
                                            </v-btn>

                                            <v-btn text @click="e1 = 3">Retour</v-btn>
                                        </v-stepper-content>
                                        <v-stepper-content step="5">
                                            <label style="font-weight: bold; margin-bottom: 2%; font-size: 12pt">
                                                Etape:5 Fin (optionnel)</label>
                                            <v-row>
                                                <v-col cols="12" sm="12" md="12">
                                                    <v-textarea
                                                            v-model="editedItem.tamp"
                                                            rows="2"
                                                            clearable
                                                            label="Titulaire de l'autorisation de mise en place"
                                                            value=""
                                                    ></v-textarea>
                                                </v-col>
                                            </v-row>
                                            <v-row>
                                                <v-col cols="12" sm="12" md="12">
                                                    <v-textarea
                                                            v-model="editedItem.namm"
                                                            rows="2"
                                                            clearable
                                                            label="Numéro d'autorisation de mise sur le marché"
                                                            value=""
                                                    ></v-textarea>
                                                </v-col>
                                            </v-row>
                                            <v-row>
                                                <v-col cols="12" sm="12" md="12">
                                                    <v-textarea
                                                            v-model="editedItem.dpa"
                                                            rows="2"
                                                            clearable
                                                            label="Date de première autorisation/renouvellement d'autorisation"
                                                            value=""
                                                    ></v-textarea>
                                                </v-col>
                                            </v-row>

                                            <v-row>
                                                <v-col cols="12" sm="12" md="12">
                                                    <v-textarea
                                                            v-model="editedItem.dosimetre"
                                                            rows="2"
                                                            clearable
                                                            label="Dosimètre"
                                                            value=""
                                                    ></v-textarea>
                                                </v-col>
                                            </v-row>
                                            <v-row>
                                                <v-col cols="12" sm="12" md="12">
                                                    <v-textarea
                                                            v-model="editedItem.ipr"
                                                            rows="2"
                                                            clearable
                                                            label="Instruction pour la préparation des radiopharmaceutiques"
                                                            value=""
                                                    ></v-textarea>
                                                </v-col>
                                            </v-row>
                                            <v-row>
                                                <v-col cols="12" sm="12" md="12">
                                                    <v-textarea
                                                            v-model="editedItem.cpd"
                                                            rows="2"
                                                            clearable
                                                            label="Condition de presription et de délivrance"
                                                            value=""
                                                    ></v-textarea>
                                                </v-col>
                                            </v-row>


                                            <v-btn @click="save" color="success" style="margin-right: 1%"> Finaliser
                                            </v-btn>


                                            <v-btn text @click="e1 = 4">Retour</v-btn>
                                        </v-stepper-content>

                                    </v-stepper-items>
                                </v-stepper>

                            </v-form>

                        </v-card>
                    </div>
                </div>
                <v-snackbar
                        v-model="snackbar"
                        timeout="2000"
                >
                    {{ textSnack }}

                    <template v-slot:action="{ attrs }">
                        <v-btn
                                color="blue"
                                text
                                v-bind="attrs"
                                @click="snackbar = false"
                        >
                            Fermer
                        </v-btn>
                    </template>
                </v-snackbar>

            </div> <!-- container-fluid -->
        </div>
        <!-- End Page-content -->

    </div>
</template>

<script>
    import {mapState} from "vuex";
    import $ from "jquery";


    export default {
        name: "Produit",
        components: {},
        data() {
            return {
                submitting: false,
                valid: true,
                lazy: false,
                step1: false,
                img_form: false,
                overlay: false,
                errors: {},
                search: '',
                user: JSON.parse(localStorage.getItem("user")),
                dialog: '',
                id: undefined,
                snackbar: false,
                textSnack: '',
                composition: [""],
                quantity: [""],
                e1: 1,
                editedIndex: -1,
                editedItem: {
                    reference: '',
                    denomination: '',
                    categorie_slug: '',
                    alt: '',
                    ci: '',
                    fp: '',
                    photo: undefined,
                    composition: [],
                    quantity: [],
                    cpd: "",
                    dc: "",
                    dosimetre: "",
                    dpa: "",
                    dps: "",
                    eacvum: "",
                    ei: "",
                    gs: "",
                    ic: "",
                    imafi: "",
                    ipr: "",
                    it: "",
                    le: "",
                    mgspe: "",
                    namm: "",
                    ncee: "",
                    pc: "",
                    pd: "",
                    pma: "",
                    ppc: "",
                    ppem: "",
                    sd: "",
                    tamp: "",
                    default_price: "",
                    _id: 0,
                    created_at: 0,
                },
                defaultItem: {
                    reference: '',
                    denomination: '',
                    categorie_slug: '',
                    alt: '',
                    ci: '',
                    fp: '',
                    photo: undefined,
                    composition: [],
                    quantity: [],
                    cpd: "",
                    dc: "",
                    dosimetre: "",
                    dpa: "",
                    dps: "",
                    eacvum: "",
                    ei: "",
                    gs: "",
                    ic: "",
                    imafi: "",
                    ipr: "",
                    it: "",
                    le: "",
                    mgspe: "",
                    namm: "",
                    ncee: "",
                    pc: "",
                    pd: "",
                    pma: "",
                    ppc: "",
                    ppem: "",
                    sd: "",
                    tamp: "",
                    default_price: "",
                    _id: 0,
                    created_at: 0,
                }

            }
        }
        ,
        computed: {
            formTitle() {
                return this.editedIndex === -1 ? "Nouvelle catégorie" : "Mise à jour"
            }
            ,
            ...mapState('categories/', ['categories']),
            ...mapState('formepharmacetiques/', ['formepharmacetiques']),
            ...mapState('produits/', [{produits:'oneproduits'}])

        }
        ,
        mounted() {
            this.$store.dispatch('categories/getCategories').then(response => {
                window.console.log('categories', response)
            });
            this.$store.dispatch('formepharmacetiques/getFormepharmacetique').then(response => {
                window.console.log('formepharmacetiques', response)
            });

            let update_id = $("#update_id").val();
            console.log('update : '+update_id.trim().length);
            if (update_id.trim().length > 0) {
                this.editedIndex = 0;
                let data = new FormData();
                data.append("id", update_id);
                this.$store.dispatch('produits/getOnceProduits', data).then(response => {
                    // window.console.log('produits', response.data.produits[0])
                    this.editedItem = response.data.produits[0];
                    console.log('produits', this.editedItem);
                    this.composition = this.editedItem.composition;
                    this.quantity = this.editedItem.quantity;
                    this.editedItem.fp = this.editedItem.fp._id;
                    this.editedItem.categorie_slug = this.editedItem.categorie_slug._id;
                    this.editedItem.photo = null;
                });
            }
            console.log('user : '+JSON.stringify(this.user) );
        }
        ,
        watch: {
            dialog(val) {
                val || this.close()
            },
        }
        ,
        methods: {
            initialize() {

            },
            add_cqq() {
                let tab_composition = [];
                let tab_quantity = [];
                console.log("cqq");
                let i = 0;
                $('input[name^="composition"]').each(function () {
                    tab_composition[i] = $(this).val();
                    i++;
                });
                tab_composition[i] = "Nouveau";
                i = 0;
                $('input[name^="quantity"]').each(function () {
                    tab_quantity[i] = $(this).val();
                    i++;
                });
                tab_quantity[i] = "Nouveau";
                this.composition = [];
                this.quantity = [];
                this.composition = tab_composition;
                this.quantity = tab_quantity;
                console.log(this.composition);
                console.log(this.quantity);


            },
            remove_cqq(index) {
                $("#" + index + 'row').remove();
                let tab_composition = [];
                let tab_quantity = [];
                console.log("cqq");
                let i = 0;
                $('input[name^="composition"]').each(function () {
                    tab_composition[i] = $(this).val();
                    i++;
                });
                i = 0;
                $('input[name^="quantity"]').each(function () {
                    tab_quantity[i] = $(this).val();
                    i++;
                });
                this.composition = [];
                this.quantity = [];
                this.composition = tab_composition;
                this.quantity = tab_quantity;
                console.log(this.composition);
                console.log(this.quantity);
            },
            Preview_image(e) {
                if (e) {
                    //  this.img_form = true;
                    $('#image_id').attr('src', URL.createObjectURL(e)); // jQuery selector
                } else {
                    $('#image_id').attr('src', location.origin + '/mineimages/img_upload.png'); // jQuery selector
                }
            },
            valideBtnStep1Click() {
                this.validateStep1();
                if (!this.step1)
                    return;
                this.e1 = 2;
            },
            save() {


                let user = JSON.parse(localStorage.getItem("user"));
                this.validateStep1();
                if (!this.step1)
                    return;
                this.overlay = true;
                let data = new FormData();
                data.append("reference", this.editedItem.reference);
                data.append("categorie_slug", this.editedItem.categorie_slug);
                data.append("cpd", this.editedItem.cpd);
                data.append("dc", this.editedItem.dc);
                data.append("denomination", this.editedItem.denomination);
                data.append("dosimetre", this.editedItem.dosimetre);
                data.append("dpa", this.editedItem.dpa);
                data.append("dps", this.editedItem.dps);
                data.append("eacvum", this.editedItem.eacvum);
                data.append("ei", this.editedItem.ei);
                data.append("fp", this.editedItem.fp);
                data.append("gs", this.editedItem.gs);
                data.append("ic", this.editedItem.ic);
                data.append("imafi", this.editedItem.imafi);
                data.append("ipr", this.editedItem.ipr);
                data.append("it", this.editedItem.it);
                data.append("le", this.editedItem.le);
                data.append("mgspe", this.editedItem.mgspe);
                data.append("namm", this.editedItem.namm);
                data.append("ncee", this.editedItem.ncee);
                data.append("pc", this.editedItem.pc);
                data.append("pd", this.editedItem.pd);
                data.append("file", this.editedItem.photo);
                data.append("pma", this.editedItem.pma);
                data.append("ppc", this.editedItem.ppc);
                data.append("ppem", this.editedItem.ppem);
                data.append("sd", this.editedItem.sd);
                data.append("tamp", this.editedItem.tamp);
                data.append("user", user._id);
                if (user.relation!==null){
                    data.append("relation", user.relation._id);
                } else{
                    data.append("relation", null);
                }
                data.append("default_price", this.editedItem.default_price);
                data.append("composition", JSON.stringify(this.editedItem.composition));
                data.append("quantity", JSON.stringify(this.editedItem.quantity));
                let mineroute = 'produits/setProduit';
                if (this.editedIndex > -1) {
                    data.append("id", this.editedItem._id);
                    mineroute = 'produits/setUpdateProduit';
                }
                console.log("ELE");
                console.log(this.editedItem);
                this.$store.dispatch(mineroute, data).then((response) => {
                    console.log('response', response);
                    this.snackbar = true;
                    this.textSnack = response.data.message;
                    this.overlay = false;
                    if (response.data.error) {
                        if (response.data.message.keyValue.reference) {
                            this.textSnack = "Ce produit existe déjà";
                            this.errors.reference = "Cette référence a été déjà utilisée";
                        } else {
                            this.errors.operation = response.data.message;
                        }
                    } else {
                         if (user.relation!==null){
                             this.$router.push("pharmaproduits");
                         } else{
                             this.$router.push("produits");
                         }
                        this.reset();
                    }
                })
            },
            validateStep1() {
                this.errors = {};
                if (this.editedItem.reference === null || this.editedItem.reference.trim().length === 0) {
                    this.errors.reference = "Référence  requise";
                }
                if (this.editedItem.denomination === null || this.editedItem.denomination.trim().length === 0) {
                    this.errors.denomination = "Dénomination  requise";
                }
                if (this.editedItem.default_price === null || this.editedItem.default_price.trim().length === 0) {
                    this.errors.default_price = "Prix  requis";
                }

                let tab_composition = [];
                let tab_quantity = [];
                let i = 0;
                $('input[name^="composition"]').each(function () {
                    tab_composition[i] = $(this).val();
                    i++;
                });
                i = 0;
                $('input[name^="quantity"]').each(function () {
                    tab_quantity[i] = $(this).val();
                    i++;
                });
                this.composition = [];
                this.quantity = [];
                this.composition = tab_composition;
                this.quantity = tab_quantity;
                this.editedItem.composition = this.composition;
                this.editedItem.quantity = this.quantity;
                if (this.composition.length > 0 || this.quantity.length > 0) {
                    console.log("c " + this.composition[0]);
                    console.log("q " + this.quantity[0]);
                    if (this.composition[0] === null || this.composition[0] === ""
                        || this.composition[0].trim().length === 0
                        || this.quantity[0] === null || this.quantity[0] === ""
                        || this.quantity[0].trim().length === 0) {
                        this.errors.cqq = "Compositions quantitatives et qualitatives  requises";
                    }
                } else {
                    this.errors.cqq = "Compositions quantitatives et qualitatives  requises";
                }

                console.log("fp : " + this.editedItem.fp);
                if (this.editedItem.fp === null || this.editedItem.fp.trim().length === 0) {
                    this.errors.fp = "Forme pharmaceutique requise";
                }


                if (this.editedItem.categorie_slug === null || this.editedItem.categorie_slug.trim().length === 0) {
                    this.errors.categorie_slug = "Catégorie requise";
                }


                console.log(this.editedItem.photo);
                if (this.editedItem.photo === null || this.editedItem.photo === undefined) {
                    if (this.editedIndex < 0) {
                        this.errors.photo = "Photo requise";
                    } else {
                        this.editedItem.photo = null;
                    }

                }


                this.step1 = Object.keys(this.errors).length === 0;
            },
            validate() {
                this.$refs.form.validate()
            },
            reset() {
                this.$refs.form.reset()
            },
            checkisDashboard() {
                this.$emit('checkisDashboard', true);
            },
            getColor() {
                return "#009587";
            }
        },
        created() {
            this.checkisDashboard();
            this.initialize()
        }

    }
</script>

<style scoped>

</style>